import React from 'react';
import Locale from '../domain/Locale';
import ProductDomain from '../domain/Product';
import Color from '../domain/Color';
import ProductConditions from './ProductConditions';
import ProductShippings from './ProductShippings';
import ProductCustomPayments from './ProductCustomPayments';
import ProductPayments from './ProductPayments';
import MarkdownComponent from './MarkdownComponent';
import get_bundle from '../domain/get_bundle';
import { t, props } from 'tcomb-react';
import cx from 'classnames';

@props({
  locale: Locale,
  product: ProductDomain,
  themeBtnColor: t.maybe(Color)
})
export default class ProductDetails extends React.Component {

  constructor(...args) {
    super(...args);
    this.state = {
      selected: 'details',
      themeBtnColor: this.props.themeBtnColor  || '#333'
    }
  }

  /*componentWillReceiveProps = function (nextProps) {
    if (nextProps.themeBtnColor !== this.state.themeBtnColor) {
      this.setState({
        themeBtnColor: nextProps.themeBtnColor
      })
    }
  }*/

  changeTab = (newTab, evt) => {
    if (evt) {
      evt.preventDefault()
    }
    this.setState({selected: newTab})
  }

  getClasses = (tab) => {
    return cx({
      'tabcontent': true,
      'active': this.state.selected === tab
    })
  }

  getStyle = (tab) => {
    if ( tab !== this.state.selected) {
      return {
        width: '25%',
        fontWeight: 'normal'
      }
    }
    return {
      width: '25%',
      fontWeight: 'normal',
      borderBottom: '5px solid ' + this.props.themeBtnColor
    }
  }

  render() {
    const { product, locale} = this.props;
    const bundle = get_bundle(locale);

    let tabDetailsClasses = cx({
      'tablinks': true,
      'active': this.state.selected === 'details'
    })

    let tabConditionsClasses = cx({
      'tablinks': true,
      'active': this.state.selected === 'conditions'
    })

    let tabShippingsClasses = cx({
      'tablinks': true,
      'active': this.state.selected === 'shippings'
    })

    let tabPaymentsClasses = cx({
      'tablinks': true,
      'active': this.state.selected === 'payments'
    })

    let detailsClasses = cx({
      'tabcontent': true,
      'active': this.state.selected === 'details'
    })

    let conditionsClasses = cx({
      'tabcontent': true,
      'active': this.state.selected === 'conditions'
    })

    let shippingsClasses = cx({
      'tabcontent': true,
      'active': this.state.selected === 'shippings'
    })

    let paymentsClasses = cx({
      'tabcontent': true,
      'active': this.state.selected === 'payments'
    })


    let tabDetailsStyle = this.getStyle('details')
    let tabConditionsStyle = this.getStyle('conditions')
    let tabShippingsStyle = this.getStyle('shippings')
    let tabPaymentsStyle = this.getStyle('payments')


    return (
      <div className="light product_details">
        <div className="tab" >
          <button style={this.getStyle('details')} className={tabDetailsClasses} onClick={this.changeTab.bind(this, 'details')}>{bundle.product.product.details}</button>
          <button style={this.getStyle('conditions')} className={tabConditionsClasses} onClick={this.changeTab.bind(this, 'conditions')}>{bundle.product.product.conditions.title}</button>
          <button style={this.getStyle('shippings')} className={tabShippingsClasses} onClick={this.changeTab.bind(this, 'shippings')}>{bundle.product.product.shippings}</button>
          <button style={this.getStyle('payments')} className={tabPaymentsClasses} onClick={this.changeTab.bind(this, 'payments')}>{bundle.product.product.payments}</button>
        </div>
        <div id="details" className={detailsClasses}>
          <MarkdownComponent>{product.details}</MarkdownComponent>
        </div>
        <div id="conditions" className={conditionsClasses}>
          <ProductConditions locale={locale} product={product}/>
        </div>
        <div id="shippings" className={shippingsClasses}>
          <ProductShippings locale={locale} product={product}/>
        </div>
        <div id="payments" className={paymentsClasses}>
          <ProductCustomPayments locale={locale} customPayments={product.custom_payments}/>
          <ProductPayments locale={locale} payments={product.payments}/>
        </div>
      </div>
    )

    /*return (
      <div className="box light product_details">
        <h3>{bundle.product.product.details}</h3>
        <MarkdownComponent>{product.details}</MarkdownComponent>
        <h3>{bundle.product.product.conditions.title}</h3>
        <ProductConditions locale={locale} product={product}/>
        <h3>{bundle.order.shippings.title}</h3>
        <ProductShippings locale={locale} product={product}/>
        <h3>{bundle.product.product.payments}</h3>
        <ProductCustomPayments locale={locale} customPayments={product.custom_payments}/>
        <ProductPayments locale={locale} payments={product.payments}/>
      </div>
    );*/
  }
}



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/components/ProductDetails.js
 **/